var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"type-button",class:_vm._class,style:(_vm._style),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default",[_vm._v("\n\t\t行动按钮\n\t")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }